import Close from "assets/svg/close.svg";
import Play from "assets/svg/play.svg";
import Head from "next/head";
import Image from "next/image";
import videoBackground from "public/images/videos-bg.png";
import React, { FC, useState } from "react";

import { Title } from "..";
import Modal from "../Modal";
import HalfPriceTraffic from "@components/HalfPriceTraffic";

type Props = {
  url: string;
  name?: string;
  description?: string;
  date?: string;
  schemaName?: string;
  isSchema?: boolean;
};

const Video: FC<Props> = ({
  url,
  name,
  date,
  description,
  schemaName,
  isSchema = false,
}) => {
  const [isShowVideoModal, setIsShowVideoModal] = useState(false);
  return (
    <>
      {isSchema && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: `{
                    "@context": "https://schema.org",
                    "@type": "VideoObject",
                    "thumbnailUrl":"https://dadbanan.com/images/logo-white.png",
                    "name": "${
                      (schemaName as string)?.replace(/"/g, " ") ?? "ویدیو"
                    }",
                    "description": "${
                      (description as string)?.replace(/"/g, " ") ??
                      (schemaName as string)?.replace(/"/g, " ")
                    }" ,
                    "uploadDate": "${date ?? Date.now()}",
                    "contentUrl": "${url}",
                    "interactionStatistic": {
                        "@type": "InteractionCounter",
                        "interactionType": { "@type": "WatchAction" }
                    },
                    "regionsAllowed": "IR"
              }`,
            }}
          />
        </Head>
      )}
      <Modal
        visible={isShowVideoModal}
        onClose={() => setIsShowVideoModal(false)}
        className="h-screen w-screen"
      >
        <div className="relative mx-auto h-60 w-10/12 rounded bg-black md:h-96 md:w-8/12 xl:h-190">
          <video controls src={url} className="h-full w-full" />
          <Close
            onClick={() => setIsShowVideoModal(false)}
            className="absolute top-5 left-5 cursor-pointer fill-white"
          />
          <HalfPriceTraffic classes="absolute top-[1rem] right-[1rem] z-50 rounded" type="VIDEO" spaces="pr-2 md:pr-4 !ml-2" text = "هزینه اینترنت مصرفی : نیم‌بها" />
        </div>
      </Modal>
      <div
        className={`h-auto bg-transparent py-5 transition-all md:rounded`}
        style={{
          contain: "content",
        }}
      >
        <div className={`transition-all`} style={{ contain: "content" }}>
          <Title
            type="LINE"
            title="ویدئو دوره"
            wrapperClass="mb-5 px-6 md:px-0"
          />
          <div className="relative flex h-80 w-full md:h-96 md:rounded xl:h-80">
            <Image
              src={videoBackground}
              alt="background"
              className="h-full w-full"
            />
            <div
              className="absolute top-0 h-full w-full px-6 py-5 text-white md:rounded md:p-5"
              style={{
                background:
                  "linear-gradient(269.74deg, rgba(54, 100, 148, 0.9) 0.22%, rgba(4, 128, 212, 0.9) 52.6%, rgba(39, 178, 188, 0.9) 99.79%)",
              }}
            >
              <div className="grid h-full grid-cols-1 content-center gap-x-2 xl:grid-cols-[_1fr,1.5fr]">
                <div className="flex h-auto flex-col justify-center xl:h-full">
                  <span className="mb-5 text-lg">نمونه ویدئو آموزشی دوره</span>
                  <p className="mb-3 text-sm">{name}</p>
                </div>
                <div className="relative flex h-52 w-full items-center justify-center rounded xl:h-full">
                  <video
                    src={url}
                    className="h-full w-full rounded xl:max-h-[300px]"
                  />
                  <Play
                    onClick={() => setIsShowVideoModal(true)}
                    className="absolute top-1/2 left-1/2 h-16 w-16 -translate-y-1/2 -translate-x-1/2 cursor-pointer drop-shadow-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;
